import {
  LISPENDES_CERT,
  LITIGATION_SEARCH,
  PROFILE_MANAGEMENT,
  UPLOAD_SYSTEM,
} from "../../assets";
import LinkHead from "../../shared/components/LinkHead";
import { Footer } from "../../shared/Layouts/LandingPageLayout";
import AboutUs from "./aboutUs";
import Contact from "./contact";
import Faqs from "./faqs";
import Hero from "./hero";

const moreInfo = [
  {
    label: "Property Litigation Search",
    icon: LITIGATION_SEARCH,
    content:
      "Easily search for properties currently involved in land-related lawsuits across Anambra State—using official court-filed data.",
  },
  {
    label: "Certificate of Lis Pendens",
    icon: LISPENDES_CERT,
    content:
      "Get downloadable, court-backed certificates indicating a property's litigation status—available after every successful paid search.",
  },
  {
    label: "Search History & Profile Management",
    icon: PROFILE_MANAGEMENT,
    content:
      "Access your previous searches, download certificates, and manage your details in a secure personal dashboard.",
  },
  {
    label: "Admin & Court Registrar Upload System",
    icon: UPLOAD_SYSTEM,
    content:
      "Authorized users can upload, update, and manage suit records directly from courts or the Lis Pendens registry.",
  },
];
function LandingPage() {
  return (
    <>
      <LinkHead title="Lispendes - Home" content="" />
      <Hero />
      <AboutUs />
      <div className="w-full bg-[#F7F7F7] lg:px-20 px-10 py-10 lg:mt-5 -mt-20">
        <div className="w-full flex items-center lg:flex-row flex-col justify-between">
          <div className="flex flex-col gap-y-2 w-full">
            <span className="text-sm font-semibold text-globalGold">
              Accurate, Secure, and Transparent Litigation Information
            </span>
            <span className="lg:text-[32px] leading-[40px] text-2xl font-bold text-black">
              Simplifying Property Verification Across Anambra State
            </span>
          </div>
          <span className="text-black font-medium text-[16px]  text-start lg:mt-2 mt-3">
            Our digital registry connects users to verified legal information on
            property disputes—ensuring safer transactions, faster due diligence,
            and informed decision-making.
          </span>
        </div>
        <div className="mt-10 flex items-center lg:flex-row flex-col justify-between lg:space-x-5 gap-5">
          {moreInfo.map((item) => (
            <div className="px-5 pt-6 pb-8 flex flex-col min-h-[290px] bg-white rounded-xl border-t-[2px] border-globalGold rounded-t-2xl items-center justify-start gap-y-2">
              <img
                src={item.icon}
                className="w-[100px] h-[100px] -mb-9 "
                alt=""
              />
              <span className="text-[16px] font-semibold text-center text-black">
                {item.label}
              </span>
              <span className="text-[#333333]   font-medium text-sm text-center">
                {item.content}
              </span>
            </div>
          ))}
        </div>
      </div>
      <Contact />
      <Faqs />
      <Footer />
    </>
  );
}

export default LandingPage;
